// src/services/authService.js
import api from './api';

export const getActivitys = async (fecha, page, limit) => {
  const response = await api.get('/actividades', {
    params: { fecha, page, limit },
  });
  return response.data;
};

export const submitActivity = async (data) => {
    const response = await api.post('/actividades', data);
    return response.data;
};

export const downloadExcelReport = async (fecha) => {
  const response = await api.get('/actividades/informe', {
    params: { fecha },
    responseType: 'blob', // Important for downloading binary files
  });

  // Create a link element
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'informe_actividades.xlsx'); // or any other extension
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};